import React from 'react';
import './OurGames.css';

const OurGames = () => {
  return (
    <div className="our-games-page">
      <iframe
        src="/our-games.html"
        title="Our Games"
        className="our-games-iframe"
        allow="fullscreen"
      />
    </div>
  );
};

export default OurGames;
